import { Sparkles } from '../icons';
import './AiAuraFab.css';

/**
 * AiAuraFab — 콘텐츠 영역 우측 하단에 떠 있는 AI 단추.
 *
 * 오라는 정본 **D15 AuraRing**(`styles/aura.css` 의 `.wc-aura`)을 그대로 두른다.
 * 실측 출처는 www.naver.com 의 AI 탭 버튼 호버이고, 색만 제품 토큰이라 5테마를 따라간다.
 *
 * ⚠ 감싸는 두 겹(`__glow`·`__ring`)은 `position: absolute` 라 `static` 인 형제보다
 *   **나중에 칠해진다** — 얼굴에 `wc-aura__face` 를 빼면 글자·아이콘이 오라에 덮인다.
 *
 * ⚠ 얼굴이 두 겹인 이유 — 바깥 `__face` 는 색 없는 3px 틈이고 색은 안쪽 `__btn` 이 갖는다.
 *   호버 바탕이 링과 같은 `--primary` 라 붙여 놓으면 링이 묻힌다(CSS 머리말 참조).
 *
 * 놓는 쪽 계약: 담는 상자가 `position: relative` 여야 자리가 잡힌다(정본 D15 주석).
 */
export function AiAuraFab({
  onClick,
  label = 'AI',
  title = 'AI 와 대화',
}: {
  onClick: () => void;
  /** 단추에 보이는 글자. 좁은 자리에서는 짧게 준다. */
  label?: string;
  /** 접근성 이름 겸 툴팁 — 「무엇이 일어나는가」를 적는다. */
  title?: string;
}) {
  return (
    <span
      className="ai-fab wc-aura"
      style={{ ['--wc-aura-r' as string]: 'var(--radius-full)', ['--wc-aura-w' as string]: '2px', ['--wc-aura-out' as string]: '9px' }}
    >
      <span className="wc-aura__glow" aria-hidden />
      <span className="wc-aura__ring" aria-hidden />
      <span className="ai-fab__face wc-aura__face">
        <button
          type="button"
          className="ai-fab__btn"
          onClick={onClick}
          title={title}
          aria-label={title}
        >
          <Sparkles size={17} aria-hidden />
          {label}
        </button>
      </span>
    </span>
  );
}
